import { CoverExtra, ExtendedBaseCoverExtra, ProtectionExtraIds } from '~/lib/consts/extras';
import { ExtraBase, QuoteApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export const QuoteProtectionOptionsAreMutuallyExclusive = (quote: QuoteApiModel): boolean => {
  return QuoteServiceProtectionOptionsAreMutuallyExclusive(quote?.Service);
};

export const QuoteServiceProtectionOptionsAreMutuallyExclusive = (service: { Tags: string[] }): boolean => {
  return service?.Tags?.includes('QuoteApi');
};

export function ItemExtrasPostQuoteProtectionCorrector(
  item: SmartSendItemApiModel,
  quote: QuoteApiModel
): {
  item: SmartSendItemApiModel;
  unsaved: string[];
  state: 'NEW' | 'INITIAL' | 'IDLE' | 'ERROR' | 'QUOTE' | 'QUOTING' | 'LOADING' | 'SAVE' | 'SAVING' | 'RETURN';
  changed: boolean;
} {
  const quoteToUse = quote || item.State?.validation?.QuoteState?.Quote;

  // (Legacy Api Migration Fix)
  if (QuoteProtectionOptionsAreMutuallyExclusive(quoteToUse)) {
    const selected = item.Extras.filter((e) => ProtectionExtraIds.includes(e.Id));
    const available: ExtraBase[] = [];
    quoteToUse.Options.forEach((o) => {
      o.AvailableExtras.filter((e) => ProtectionExtraIds.includes(e.Id)).forEach((e) => {
        if (!available.some((x) => x.Id === e.Id)) {
          available.push(e);
        }
      });
      o.Extras.filter((e) => ProtectionExtraIds.includes(e.Id)).forEach((e) => {
        if (!available.some((x) => x.Id === e.Id)) {
          available.push(e);
        }
      });
    });

    if (available.length == 1 && selected.some((e) => !available.some((x) => x.Id === e.Id))) {
      // Scenarios:
      // Item has both, quote has one -> remove the unavailable option on the item
      // Item has cover, quote has extended base cover -> remove cover from item and add extended base cover.
      if (selected.length > 1 || (selected[0].Id === CoverExtra && available[0].Id === ExtendedBaseCoverExtra)) {
        // Remove all protection
        item.Extras = item.Extras.filter((e) => !ProtectionExtraIds.includes(e.Id));

        // Add the one from the quote
        available.forEach((e) => {
          if (!item.Extras.some((x) => x.Id === e.Id)) {
            item.Extras.push(e);
          }
        });

        // Force Save
        item.State.unsaved = ['Extras'];
        item.State.state = 'SAVE';

        // Return Changes and New State
        return {
          item: item,
          unsaved: item.State.unsaved,
          state: item.State.state,
          changed: true
        };
      }
    }
  }

  return {
    item: item,
    unsaved: [],
    state: null,
    changed: false
  };
}
